import { isEmpty, isNil } from 'lodash';
import { useSelector } from 'react-redux';

import { useGetOrganizationProfileQuery } from '@modules/rtk/esb-api';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

export function useActiveOrganization() {
  const orgGuid = useSelector(organizationGuidSel);
  const response = useGetOrganizationProfileQuery(
    {
      orgGuid,
    },
    { skip: isNil(orgGuid) || isEmpty(orgGuid) },
  );

  return response;
}
